<!--
 * @ Author: Your name
 * @ Create Time: 2019-05-25 10:25:38
 * @ Modified by: Your name
 * @ Modified time: 2019-07-22 10:56:18
 * @ Description: 开箱日志
 -->

<template>
  <div class="content-wrapper">
    <el-form label-width="100px" label-position="right"
      ref="searchForm" :model="formData.data"
      v-loading="formLoading" class="search-form" :inline="true">
      <div>
        <el-form-item label="触发时间" prop="triggerTimes">
          <el-date-picker
            v-model="triggerTimes"
            size='small'
            type="datetimerange"
            format="yyyy-MM-dd HH:mm:ss"
            value-format='yyyy-MM-dd HH:mm:ss'
            :default-time="['00:00:00', '23:59:59']"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="触发类型" prop="triggerType">
          <el-select v-model="formData.data.triggerType"
            clearable placeholder="请选择" size="small">
            <el-option value="" label="全部"></el-option>
            <el-option
              v-for="item in triggerTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" size="small" class="search-btn"
          @click="searchTableData" icon="el-icon-search"
          :loading="loadingSearch">查询</el-button>
        <el-button type="warning" size="small" @click="handleBack()"
          icon="el-icon-refresh-left" v-if='hopRouting'>返回设备管理</el-button>
      </div>
    </el-form>
    <table-pagination
      ref="table"
      :tableData="tableData"
      :height='500'
      :loading='tableLoading'
      service
      @service-fn="handleService"
      @row-click="rowClick">
      <el-table-column prop="deviceNumber" label="智能柜编号" align="center" />
      <el-table-column prop="deviceName" label="智能柜名称" align="center" />
      <el-table-column prop="cabinetNumber" label="柜子编号" align="center" />
      <el-table-column prop="cabinetName" label="柜子名字" align="center" />
      <el-table-column prop="cabinetDoorNo" label="柜门编号" align="center" />
      <el-table-column prop="cabinetDoorName" label="柜门号" align="center" />
      <el-table-column prop="triggerType" label="触发类型" sortable align="center" width="120">
        <template slot-scope="scope">
          {{formatColumn(scope.column.property, scope.row.triggerType)}}
        </template>
      </el-table-column>
      <el-table-column prop="triggerPerson" label="触发人" align="center" show-overflow-tooltip />
      <el-table-column prop="triggerTime" label="触发时间" align="center" show-overflow-tooltip
        :formatter='formatterTime'/>
      <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip />
    </table-pagination>
  </div>
</template>

<script>
import tables from '../../mixins/table'
import { UNPACKLOG } from '../../libs/api'

export default {
  mixins: [tables],
  data() {
    return {
      hopRouting: this.$route.query.path, // 判断是否是由设备管理跳转过来的
      loadingSearch: false,
      tableLoading: false,
      formLoading: false, // 表单加载遮罩
      formInited: true, // 表单是否已完成初始化
      formData: {
        pageNum: 1,
        pageSize: 10,
        orderBy: '',
        data: {
          triggerType: '', // 触发类型
          startTime: '', // 触发开始时间
          endTime: '', // 触发结束时间
          deviceNumber: this.$route.query.deviceNumber // 设备管理页面 跳转过来的 deviceNumber
        }
      },
      triggerTimes: '', // 触发时间
      triggerTypeList: [{
        label: '管理员开箱',
        value: 0
      }, {
        label: '配送员配送',
        value: 1
      }, {
        label: '取消配送',
        value: 2
      }, {
        label: '领取人领取',
        value: 3
      }, {
        label: '退料人退料',
        value: 4
      }, {
        label: '取消退料',
        value: 5
      }, {
        label: '配送员领取退料',
        value: 6
      }],
      dic: { // 字典格式化
        triggerType: {
          0: '管理员开箱',
          1: '配送人配送',
          2: '取消配送',
          3: '领取人领取',
          4: '退料人退料',
          5: '取消退料',
          6: '配送员领取退料'
        }
      },
      searchUrl: UNPACKLOG.GET_LIST
    }
  },
  mounted() {
    // table 数据表查询
    this.searchTableData()
  },
  methods: {
    formatColumn(cellName, cellValue) {
      return this.dic[cellName][cellValue]
    },
    handleBack() { // 返回上一个跳转过来的页面
      this.$router.push({ path: `${this.hopRouting}` })
    },
    searchTableData() {
      // 将触发事件 拆分成两个时间（开始、结束）
      /* eslint-disable */ 
      if (this.triggerTimes) {
        this.formData.data.startTime = this.triggerTimes[0]
        this.formData.data.endTime = this.triggerTimes[1]
      } else {
        this.formData.data.startTime = ''
        this.formData.data.endTime = ''
      }
      this.handleSearch(this.searchUrl, this.formData)
    }
  }
}
</script>

<style lang="scss" scoped>
.search-form{
  padding-right: 40px;
  .el-form-item{
    margin-bottom: 0px;
  }
  .el-button{
    margin-top: 5px;
  }
}
</style>
